module.exports = __webpack_public_path__ + "img/ic_qmarker_trailer_lbl_issue.feb37174.png";